import { createAction, props } from '@ngrx/store';
export const GET_TRIP = '[Trip] Get Trip';
export const GET_TRIP_SUCCESS = '[Trip] Get Trip Success';
export const GET_TRIP_FAILURE = '[Trip] Get Trip Failures';

//create Trip actions
export const CREATE_TRIP = '[Trip] Create Trip';
export const CREATE_TRIP_SUCCESS = '[Trip] Create Trip Success';
export const CREATE_TRIP_FAILURE = '[Trip] Create Trip Failures';
//Update Trip Actions
export const UPDATE_TRIP = '[Trip] Update Trip';
export const UPDATE_TRIP_SUCCESS = '[Trip] Update Trip Success';
export const UPDATE_TRIP_FAILURE = '[Trip] Update Trip Failures';

//GET Trip By Id
export const GET_TRIP_BY_ID = '[User] Get Trip By ID';
export const GET_TRIP_BY_ID_SUCCESS = '[Trip] Get Trip By ID Success';
export const GET_TRIP_BY_ID_FAILURE = '[Trip] Get Trip By ID Failures';
//Delete Trip Actions
export const DELETE_TRIP = '[Trip] Delete Trip';
export const DELETE_TRIP_SUCCESS = '[Trip] Delete Trip Success';
export const DELETE_TRIP_FAILURE = '[Trip] Delete Trip Failures';

//Cities Trip Actions
export const GET_CITIES_DESTINATIONID_TRIP =
  '[Trip] GetCitiesByDestionation Trip';
export const GET_CITIES_DESTINATIONID_TRIP_SUCCESS =
  '[Trip] GetCitiesByDestionation Trip Success';
export const GET_CITIES_DESTINATIONID_TRIP_FAILURE =
  '[Trip] GetCitiesByDestionation Trip Failures';

//createactions by Get Trip
export const getTrip = createAction(GET_TRIP, props<{ queryParams?: any }>());
export const getTripSuccess = createAction(
  GET_TRIP_SUCCESS,
  props<{ data: any }>()
);
export const getTripFailure = createAction(
  GET_TRIP_FAILURE,
  props<{ data: any }>()
);
//createactions by Create Trip
export const createTrip = createAction(CREATE_TRIP, props<{ data: any }>());
export const createTripSuccess = createAction(
  CREATE_TRIP_SUCCESS,
  props<{ data: any }>()
);
export const createTripFailure = createAction(
  CREATE_TRIP_FAILURE,
  props<{ data: any }>()
);
//createactions by getBYID Trip
export const getTripById = createAction(GET_TRIP_BY_ID, props<{ id: any }>());
export const getTripByIdSuccess = createAction(
  GET_TRIP_BY_ID_SUCCESS,
  props<{ data: any }>()
);
export const getTripByIdFailure = createAction(
  GET_TRIP_BY_ID_FAILURE,
  props<{ id: any }>()
);
//createactions by DELETE Trip
export const deleteTrip = createAction(DELETE_TRIP, props<{ id: any }>());
export const deleteTripSuccess = createAction(
  DELETE_TRIP_SUCCESS,
  props<{ id: any }>()
);
export const deleteTripFailure = createAction(
  DELETE_TRIP_FAILURE,
  props<{ id: any }>()
);
//createactions by Update Trip
export const updateTrip = createAction(
  UPDATE_TRIP,
  props<{ id: any; data: any }>()
);
export const updateTripSuccess = createAction(
  UPDATE_TRIP_SUCCESS,
  props<{ id: any }>()
);
export const updateTripFailure = createAction(
  UPDATE_TRIP_FAILURE,
  props<{ id: any }>()
);

//createactions for CitiesByDestination Trip
export const getCitiesByDestionation = createAction(
  GET_CITIES_DESTINATIONID_TRIP,
  props<{ data: any }>()
);

export const getCitiesByDestionationSuccess = createAction(
  GET_CITIES_DESTINATIONID_TRIP_SUCCESS,
  props<{ data: any }>()
);

export const getCitiesByDestionationFailure = createAction(
  GET_CITIES_DESTINATIONID_TRIP_FAILURE,
  props<{ data: any }>()
);

export const ClearState = createAction('[Trip] clear state');
